function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "wireframe",
  transform: "translate(0.15 0.15)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M2.005,7.237A2.062,2.062,0,0,1,0,5.126V2.111A2.062,2.062,0,0,1,2.005,0H25.5A2.063,2.063,0,0,1,27.5,2.111V5.126A2.063,2.063,0,0,1,25.5,7.237Z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M2.111,18.092A2.05,2.05,0,0,1,0,16.114V1.979A2.05,2.05,0,0,1,2.111,0H5.126A2.05,2.05,0,0,1,7.237,1.979V16.114a2.05,2.05,0,0,1-2.111,1.978Z",
  transform: "translate(0 9.408)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-3",
  "data-name": "Shape",
  d: "M1.979,18.092A1.981,1.981,0,0,1,0,16.114V1.979A1.981,1.981,0,0,1,1.979,0H16.114a1.981,1.981,0,0,1,1.978,1.979V16.114a1.98,1.98,0,0,1-1.978,1.978Z",
  transform: "translate(9.408 9.408)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.3
}));

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.8,
    height: 27.8,
    viewBox: "0 0 27.8 27.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.5ddd5a5f.svg";
export { ForwardRef as ReactComponent };